import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DetailsViewerComponent } from './details-viewer/details-viewer.component';
import { MassTransferEditorComponent } from './mass-transfer-editor/mass-transfer-editor.component';
import { VendorsComponent } from './vendors.component';
import { SharedModule } from '../../../shared/shared.module';
import { UIModule } from '../../ui/ui.module';
import { TextInputAutocompleteModule } from 'ngx-input-autocomplete';
import { JvUiModule } from '../../../../../projects/jv-ui/src/lib/jv-ui.module';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { DepositsEditorComponent } from './deposits-editor/deposits-editor.component';
import { MassTransferResolverComponent } from './mass-transfer-resolver/mass-transfer-resolver.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    UIModule,
    TextInputAutocompleteModule,
    JvUiModule,
    SelectDropDownModule
  ],

  declarations: [
    VendorsComponent,
    DetailsViewerComponent,
    MassTransferEditorComponent,
    DepositsEditorComponent,
    MassTransferResolverComponent,
  ],

  entryComponents: [
    DetailsViewerComponent,
    MassTransferEditorComponent,
    DepositsEditorComponent,
    MassTransferResolverComponent
  ]

})
export class VendorsModule { }
